import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ads/ads-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/markdown-to-word-converter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.2.0_next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1_typescript@5.8.3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
